import React from "react";

const Minus = ({ className, title = "", fill = "#6D7881", onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{title}</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="Asset-Artboard-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icons/Add-04-|-🛠-|-Icons/Functional/minus" fill={fill}>
          <path
            d="M23.0943405,13.4000001 C23.5942651,13.4000001 24.000001,12.8624001 24.000001,12.2 C24.000001,11.5376 23.5942651,11 23.0943405,11 L0.905660413,11 C0.405735865,11 0,11.5376 0,12.2 C0,12.8624001 0.405735865,13.4000001 0.905660413,13.4000001 L23.0943405,13.4000001 Z"
            id="icon-minus"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Minus;
